import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]

  connect() {
    this.loadedPanels = new Set(['home']); // Home is loaded by default; every other tab (Maps included) loads its panel the first time it is opened

    // Check URL for product param on load
    this.checkUrlProduct();
  }

  togglePageChrome(product) {
    const isProductPage = product && product !== 'home'
    const footer = document.querySelector('footer')
    const proofBar = document.querySelector('.ge-proof-bar')

    if (footer) footer.style.display = isProductPage ? 'none' : ''
    if (proofBar) proofBar.style.display = isProductPage ? 'none' : ''
  }

  switch(event) {
    const product = event.currentTarget.dataset.product

    // Load panel content if not already loaded
    this.loadPanelIfNeeded(product);

    // Hide all panels first
    this.panelTargets.forEach(panel => {
      panel.classList.remove('ge-panel--active')
    })

    // Show the target panel
    const targetPanel = this.panelTargets.find(panel => panel.dataset.product === product)
    if (targetPanel) {
      targetPanel.classList.add('ge-panel--active')
    }

    // Update desktop tab buttons
    document.querySelectorAll('.ge-nav__product').forEach(tab => {
      if (tab.dataset.product === product) {
        tab.classList.add('ge-nav__product--active')
      } else {
        tab.classList.remove('ge-nav__product--active')
      }
    })

    // Update mobile tab buttons
    document.querySelectorAll('.ge-nav__mobile-tab').forEach(tab => {
      if (tab.dataset.product === product) {
        tab.classList.add('ge-nav__mobile-tab--active')
      } else {
        tab.classList.remove('ge-nav__mobile-tab--active')
      }
    })

    // Update URL without reload
    this.updateUrl(product);

    // Hide footer and proof bar on product pages
    this.togglePageChrome(product);

    // Smooth scroll to top of page
    // If content is already loaded, scroll immediately
    if (this.loadedPanels.has(product)) {
      this.scrollToTop();
    } else {
      // For lazy-loaded content, scroll after Turbo Frame loads
      this.scrollAfterLazyLoad(product);
    }
  }

  loadPanelIfNeeded(product) {
    // Find the turbo frame for this panel
    const frameId = `${product}-panel`;
    const frame = document.getElementById(frameId);

    if (frame) {
      // Always reload home panel to ensure fresh content
      if (product === 'home' || !this.loadedPanels.has(product)) {
        const url = `/${product}_panel`;
        frame.src = url;
      }
      this.loadedPanels.add(product);
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  scrollAfterLazyLoad(product) {
    const frameId = `${product}-panel`;
    const frame = document.getElementById(frameId);

    if (frame) {
      // Listen for turbo:frame-load event
      const handleLoad = () => {
        this.scrollToTop();
        frame.removeEventListener('turbo:frame-load', handleLoad);
      };

      frame.addEventListener('turbo:frame-load', handleLoad);

      // Fallback: scroll after 500ms if event doesn't fire
      setTimeout(() => {
        frame.removeEventListener('turbo:frame-load', handleLoad);
        this.scrollToTop();
      }, 500);
    } else {
      // Fallback: immediate scroll if frame not found
      this.scrollToTop();
    }
  }

  checkUrlProduct() {
    const url = new URL(window.location);
    const product = url.searchParams.get('product');
    if (product && ['home', 'maps', 'docs', 'floorplans', 'time', 'business'].includes(product)) {
      // Find and simulate click on the appropriate tab
      const tab = document.querySelector(`[data-product="${product}"]`);
      if (tab) {
        this.switch({ currentTarget: tab });
      }
    }
  }

  updateUrl(product) {
    const url = new URL(window.location);
    url.searchParams.set('product', product);
    history.replaceState({}, '', url);
  }
}
